import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { cashWarrantApi } from 'helpers/api/cashWarrant';
import { errorToast, successToast } from 'configuration/notifications';

export const CashWarrantCard = ({
  cashWarrant,
  rentSum,
  editCashWarrant,
  deleteCashWarrant,
  isUnofficialWarrant,
  onUrlClick,
  isCapturedWarrant,
}) => {
  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const handleClickLink = () => {
    onUrlClick();
  };

  const handleSendMessage = (id) => {
    return async () => {
      const { data } = await cashWarrantApi.sendCashWarrantMessage(id);
      if (data.error) {
        errorToast(`Ошибка: ${data.message}`);
        return;
      }
      successToast('Сообщение отправлено!');
    };
  };

  const renderSum = () => (
    <li>
      <i className={cashWarrant.type === 'income' ? 'icon-profit-svg' : 'icon-cost-svg'} />
      <span>
        {cashWarrant.sum} {isUnofficialWarrant ? 'у.е.' : 'грн.'}
      </span>
    </li>
  );

  const renderCashier = () => {
    return cashWarrant.selected?.name.length > 26 ? (
      <li>
        <i className="icon-cashier-svg" />
        <span>{cashWarrant.selected?.name}</span>
        <label>{cashWarrant.selected?.name}</label>
      </li>
    ) : (
      <li>
        <i className="icon-cashier-svg" />
        <span>{cashWarrant.selected?.name}</span>
      </li>
    );
  };

  const renderComment = () =>
    cashWarrant.comment.length !== 0 ? (
      <>
        {cashWarrant.comment.length > 26 ? (
          <li>
            <i className="icon-comment-svg" />
            <span>{cashWarrant.comment}</span>
            <label>{cashWarrant.comment}</label>
          </li>
        ) : (
          <li>
            <i className="icon-comment-svg" />
            <span>{cashWarrant.comment}</span>
          </li>
        )}
      </>
    ) : (
      <></>
    );

  const renderTopBar = () => {
    if (cashWarrant.conduct || cashWarrant.isPaidOff)
      return (
        <div className="wrap-conduct-btn-icon">
          {cashWarrant.isPaidOff && (
            <div
              className="icon-payment-system-badge-svg"
              data-tip="Оплачено клиентом в Fondy"
              data-place="bottom"
            ></div>
          )}
          {cashWarrant.conduct && (
            <div className="c1-button badge-1c" data-tip="Проведено в 1С" data-place="bottom">
              1C
            </div>
          )}
        </div>
      );
    else {
      return (
        <div className="wrap-btn-icon">
          <div className="edit" onClick={editCashWarrant}>
            <div className="icon-custom-edit" />
          </div>
          <div className="delete-icon" onClick={deleteCashWarrant}>
            <div className="icon-trash-svg" />
          </div>
        </div>
      );
    }
  };

  const renderNonConduct = () => {
    if (!cashWarrant.nonConduct) return null;
    return (
      <li>
        <i className="icon-credit-svg" />
        <span>Неофициальный приходник</span>
      </li>
    );
  };

  const renderPaymentSystem = () => {
    if (
      cashWarrant.isPaidOff ||
      cashWarrant.type === 'cost' ||
      !cashWarrant?.selected?.fondyCompatible ||
      cashWarrant.nonConduct ||
      cashWarrant.sum !== rentSum
    ) {
      return null;
    }
    return (
      <>
        {cashWarrant.url ? (
          <>
            <li onClick={handleClickLink} className="payment-block">
              <i className="icon-payment-system-svg" />
              <span> скопировать ссылку </span>
            </li>
            <li onClick={handleSendMessage(cashWarrant.warrantID1C)} className="payment-block">
              <i className="icon-viber-redirect-svg" />
              <div className="send-message"> отправить ссылку на оплату</div>
            </li>
          </>
        ) : (
          <>
            <li onClick={handleClickLink} className="payment-block">
              <i className="icon-payment-system-svg" />
              <span>- получить ссылку</span>
            </li>
          </>
        )}
      </>
    );
  };

  const renderCapturePaymentSystem = () => {
    if (cashWarrant.type === 'cost' && isCapturedWarrant) {
      return (
        <li onClick={handleClickLink} className="payment-block">
          <i className="icon-payment-system-svg" />
          <span>- вернуть на карту</span>
        </li>
      );
    }
    return null;
  };

  return (
    <div className="wrap-cart-rent">
      <ul>
        {renderSum()}
        {renderCashier()}
        {renderComment()}
        {renderNonConduct()}
        {renderTopBar()}
        {renderPaymentSystem()}
        {renderCapturePaymentSystem()}
      </ul>
      <ReactTooltip />
    </div>
  );
};

CashWarrantCard.propTypes = {
  cashWarrant: PropTypes.any,
  rent: PropTypes.any,
  onUrlClick: PropTypes.func,
  editCashWarrant: PropTypes.func,
  deleteCashWarrant: PropTypes.func,
  rentSum: PropTypes.number,
  isUnofficialWarrant: PropTypes.bool,
  isCapturedWarrant: PropTypes.bool,
};

CashWarrantCard.defaultProps = {
  isCapturedWarrant: false,
};
